import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BackButtonComponent } from '../../components/back-button/back-button.component';
import { CustomerServiceComponent } from '../../components/customer-service/customer-service.component';
import { ScrollTopDirective } from '../../directives/scroll-top.directive';
import { SanitizerPipe } from '../../pipes/sanitizer.pipe';
import { FacilityInformationEmptyComponent } from './facility-information-empty/facility-information-empty.component';
import { FacilityInfComponent } from './facility-information.component';
import { GoogleMapComponent } from './google-map/google-map.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        BackButtonComponent,
        CdkAccordionModule,
        SanitizerPipe,
        GoogleMapsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        ScrollTopDirective,
        CustomerServiceComponent,
        NgOptimizedImage,
    ],
    declarations: [FacilityInfComponent, GoogleMapComponent, FacilityInformationEmptyComponent],
    exports: [FacilityInfComponent],
})
export class FacilityInformationModule {}
